import React from 'react';
import CookiePortal from './CookiePortal';

function App() {
  return <CookiePortal />;
}

export default App;